var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-solution-card px-2 py-3 text-center"},[_c('img',{attrs:{"src":require('@/assets/images/' + _vm.img),"alt":_vm.title}}),_c('p',{staticClass:"text-primary fw-bolder mb-0 text-start"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }